import { useEffect, useRef, useState } from 'react';
import { useRecoilState } from 'recoil';
import INotificationRepository from '../../2_domain/notification/iNotificationRepository';
import { NotificationHistory } from '../../2_domain/notification/notification';
import Get from '../../lib/di/get';
import promiseResolver from '../../lib/util/promiseResolver';
import newNotificationAtom from './newNotificationAtom';

const emptyPagination: Pagination = {
  pageNumber: 0,
  pageSize: 10,
  isAscending: false,
};

const useNotificationController = () => {
  const notificationRepo = Get.find<INotificationRepository>(
    'INotificationRepository'
  );
  const [data, setData] = useState<NotificationHistory[]>([]);
  const [loading, setLoading] = useState(false);
  const [isEndOfData, setIsEndOfData] = useState(false);
  const today = useRef(new Date());
  const pagination = useRef(emptyPagination);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, setNewNotification] = useRecoilState(newNotificationAtom);

  const moreDate = async () => {
    if (loading) return;
    promiseResolver({
      promise: notificationRepo.getNotificationHistories(pagination.current),
      isLoadingCallback: setLoading,
      successCallback: (data) => {
        pagination.current.pageNumber += 1;
        if (data.length < pagination.current.pageSize) {
          setIsEndOfData(true);
        }
        setData((prev) => prev.concat(data));
      },
    });
  };
  const readNotification = (id: Id) => {
    return () => {
      promiseResolver({
        promise: notificationRepo.readNotification(id),
      });
    };
  };

  useEffect(() => {
    return () => {
      promiseResolver({
        promise: notificationRepo.getNewNotificationHistories(),
        successCallback: (bool) => {
          setNewNotification(bool);
        },
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    data,
    today,
    isEndOfData,
    loading,
    moreDate,
    readNotification,
  };
};

export default useNotificationController;
